import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

/**
 * Label component with exact Hyperkit styling
 *
 * Hyperkit Specs:
 * - Font: 14px/500 (Label/Small)
 * - Color: grey-900 (light), grey-50 (dark)
 * - Gap to input: 8px (handled by parent FormField)
 */
const labelVariants = cva(
  // 14px/500 Label/Small, proper colors
  'text-sm font-medium leading-none text-grey-900 dark:text-grey-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
  {
    variants: {
      required: {
        true: "after:content-['*'] after:ml-0.5 after:text-red-500",
        false: '',
      },
      error: {
        true: 'text-red-600 dark:text-red-400',
        false: '',
      },
    },
    defaultVariants: {
      required: false,
      error: false,
    },
  }
);

const Label = React.forwardRef(({ className, required, error, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(labelVariants({ required, error }), className)}
    {...props}
  />
));
Label.displayName = 'Label';

export { Label, labelVariants };
